class PassengerList {
  adultList = [];
  childList = [];
}
export default PassengerList;
